import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=5426f739&"
import script from "./NotificationCard.vue?vue&type=script&lang=ts&"
export * from "./NotificationCard.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=5426f739&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports